var jade = require("/web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (view) {
jade_mixins["modal-footer-content"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ( view.signupState.get('screen') !== 'confirmation')
{
buf.push("<div class=\"modal-footer-content\"><div class=\"small-details rtl-allowed\"><span data-i18n=\"signup.login_switch\" class=\"spr\"></span><a class=\"login-link\"><span data-i18n=\"signup.sign_in\"></span></a></div></div>");
}
};
jade_mixins["modal-header-content"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<h3>");
switch (view.signupState.get('path')){
case 'student':
buf.push("<span data-i18n=\"signup.create_student_header\"></span>");
  break;
case 'teacher':
buf.push("<span data-i18n=\"signup.create_teacher_header\"></span>");
  break;
case 'individual':
if ( view.signupState.get('subModalContinue'))
{
buf.push("<span data-i18n=\"signup.complete_subscription\"></span>");
}
else
{
buf.push("<span data-i18n=\"signup.create_individual_header\"></span>");
}
  break;
default:
buf.push("<span data-i18n=\"login.sign_up\"></span>");
  break;
}
buf.push("</h3>");
};
buf.push("<div class=\"modal-dialog\"><div class=\"modal-content style-flat\"><div" + (jade.cls(['modal-header',view.signupState.get('path')], [null,true])) + "><span data-dismiss=\"modal\" aria-hidden=\"true\" class=\"glyphicon glyphicon-remove button close\"></span>");
jade_mixins["modal-header-content"]();
buf.push("</div>");
switch (view.signupState.get('screen')){
case 'choose-account-type':
buf.push("<div id=\"choose-account-type-view\"></div>");
  break;
case 'segment-check':
buf.push("<div id=\"segment-check-view\"></div>");
  break;
case 'eu-confirmation':
buf.push("<div id=\"eu-confirmation-view\"></div>");
  break;
case 'basic-info':
buf.push("<div id=\"basic-info-view\"></div>");
  break;
case 'coppa-deny':
buf.push("<div id=\"coppa-deny-view\"></div>");
  break;
case 'sso-already-exists':
buf.push("<div id=\"single-sign-on-already-exists-view\"></div>");
  break;
case 'sso-confirm':
buf.push("<div id=\"single-sign-on-confirm-view\"></div>");
  break;
case 'extras':
buf.push("<div id=\"extras-view\"></div>");
  break;
case 'confirmation':
buf.push("<div id=\"confirmation-view\"></div>");
  break;
case 'teacher-signup-component':
buf.push("<div id=\"teacher-signup-component\"></div>");
  break;
}
buf.push("<div" + (jade.cls(['modal-footer',view.signupState.get('path')], [null,true])) + ">");
jade_mixins["modal-footer-content"]();
buf.push("</div></div></div>");}.call(this,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/create-account-modal.jade
// module id = 863
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91